<template>
    <DxLoadPanel :position="position" class="reg-loadpanel"
                 v-model:visible="loadingVisible"
                 :show-indicator="true"
                 :copy-root-classes-to-wrapper="true"
                 :show-pane="true"
                 :shading="true"
                 :width="150"
                 message="Please wait ..."
                 shading-color="rgba(0,0,0,0.4)" />
    <div class="reg">
        <form action="your-action"
              @submit="onFormSubmit($event)">
            <div class="resp-form">
                <div class="reg-header">
                    <div @click="toLandingPage()" class="pq4-logo">
                    </div>
                    <div class="reg-welcome">
                        Create your account as a mentor
                    </div>
                    <div class="reg-welcome-text">
                        Enter your details to get started
                    </div>
                </div>
                <div class="field">
                    <div class="dx-email-value">
                        <DxTextBox v-model:value="user.UsrEmail"
                                   :show-clear-button="false"
                                   mode="email"
                                   label="Email"
                                   label-mode="static">
                            <DxValidator>
                                <DxRequiredRule message="Email is required" />
                                <DxEmailRule message="Email is invalid" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="field">
                    <div class="dx-pass-value">
                        <DxTextBox v-model:value="user.UsrPassword"
                                   :show-clear-button="false"
                                   label="Password"
                                   label-mode="static"
                                   mode="password"
                                   @keyDown="pwdKeyDown">
                            <DxValidator>
                                <DxRequiredRule message="Password is required" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="field">
                    <div class="dx-pass-value">
                        <DxTextBox :show-clear-button="false"
                                   label="Confirm Password"
                                   label-mode="static"
                                   mode="password"
                                   @keyDown="pwdKeyDown">
                            <DxValidator>
                                <DxRequiredRule message="Confirm Password is required" />
                                <DxCompareRule :comparison-target="passwordComparison"
                                               message="Password and Confirm Password do not match" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="field">
                    <!--<div class="reg-checkbox">
                        <DxCheckBox id="check"
                                    v-model:value="user.PrivacyPolicyConfirmed">
                            <DxValidator>
                                <DxCompareRule :comparison-target="checkComparison"
                                               message="You must agree to the Terms and Privacy Policy" />
                            </DxValidator>
                        </DxCheckBox>
                        <span class="reg-chk-label">
                            I’ve read and accepted the <a class="pq4-link" href="../Public/Terms.aspx" target="_blank">Terms</a> and
                            <a class="pq4-link" href="../Public/PrivacyPolicy.aspx" target="_blank">Privacy Policy</a>
                        </span>
                    </div>-->
                    <div class="reg-checkbox">
                        <span class="reg-chk-label">
                            By continuing, you agree to the <a class="pq4-link" href="../Public/Terms.aspx" target="_blank">Terms</a> and
                            <a class="pq4-link" href="../Public/PrivacyPolicy.aspx" target="_blank">Privacy Policy</a>
                        </span>
                    </div>
                   

                </div>
                <div class="field">
                    <div v-if="captchaLoaded">
                        <img :src="'data:image/jpeg;base64,' + captcha.captchaImage" />
                        <DxButton icon="refresh" @click="refreshCaptcha" />
                    </div>
                    <div class="reg-captcha">
                        <DxTextBox v-model:value="user.CaptchaCode"
                                   :show-clear-button="false"
                                   label="Type the Code"
                                   label-mode="static">
                            <DxValidator>
                                <DxRequiredRule message="Captcha code is missing" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="field">
                    <div class="reg-err-msg" v-if="hasMessage">
                        {{ errorMessage }}
                    </div>
                    <div class="reg-btns">
                        <!--<DxValidationSummary id="summary" />-->
                        <DxButton class="logBtn"
                                  text="Register"
                                  :use-submit-behavior="true"
                                  type="success" />
                    </div>

                </div>
            </div>
        </form>
        <div class="reg-footer">
            <div class="reg-back-btn pq4-link" @click="backToLogin()">Back to login</div>
        </div>
        <FooterSmall></FooterSmall>
    </div>
</template>
<script>
    import { DxButton } from 'devextreme-vue/button';
    import DxLoadPanel from 'devextreme-vue/load-panel';
    import DxTextBox from 'devextreme-vue/text-box';
    //import DxCheckBox from 'devextreme-vue/check-box';
    import FooterSmall from './widgets/FooterSmall.vue';
    import { alert } from "devextreme/ui/dialog"
    //import DxValidationSummary from 'devextreme-vue/validation-summary';
    import {
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        DxEmailRule,
        //DxPatternRule,
        //DxStringLengthRule,
        //DxRangeRule,
        //DxAsyncRule,
    } from 'devextreme-vue/validator';
    //import notify from 'devextreme/ui/notify';

    export default {

        name: 'LoginPage',
        components: {
            DxButton,
            DxTextBox,
            DxLoadPanel,
            DxValidator,
            DxRequiredRule,
            DxCompareRule,
            //DxValidationSummary,
            DxEmailRule,
            //DxCheckBox,
            FooterSmall,
        },
        data() {
            return {
                loadingVisible: false,
                errorMessage: "",
            }
        },
        mounted() {
            this.$store.dispatch("getCaptcha")
            this.$store.dispatch("getNewUser")
        },
        created: function () {

        },
        computed: {
            hasMessage() {
                return this.errorMessage && this.errorMessage.length > 0
            },
            captcha() {
                return this.$store.state.registrationStore.captcha
            },
            captchaLoaded() {
                var result = this.$store.state.registrationStore.captcha &&
                    this.$store.state.registrationStore.captcha.captchaImage &&
                    this.$store.state.registrationStore.captcha.captchaImage.length > 0
                return result
            },
            user() {
                return this.$store.state.registrationStore.user
            },
            status() {
                return this.$store.state.registrationStore.status
            },
        },
        methods: {
            toLandingPage() {
                window.location.href = "../landingPage.aspx"
            },
            backToLogin() {
                window.location.href = "../Login.aspx"
            },
            passwordComparison() {
                return this.user.UsrPassword;
            },
            checkComparison() {
                return true;
            },
            pwdKeyDown(e) {
                if (e.event.code == "Enter") {
                    this.onFormSubmit(e);
                }
            },
            onFormSubmit(e) {
                //if (this.user.PrivacyPolicyConfirmed)
                //    this.user.TermsConfirmed = true;
                this.user.PrivacyPolicyConfirmed = true;
                this.user.TermsConfirmed = true;
                this.user.GrpId = 72;
                this.user.UsrAccountLocked = false;
                this.$store.dispatch("registerSimple")
                e.preventDefault();
            },
            refreshCaptcha() {
                this.$store.dispatch("getCaptcha")
            }
        },
        watch: {
            status(newStatus) {
                if (newStatus == "registered") {
                    alert(`You have successfully registered. An email message with a confirmation<br/>
                        link was sent to the address you provided. After you have confirmed your<br/>
                        email address with this link, you can log in.`,
                        "Registration").then(() => {
                            window.location.href = '../Login.aspx'
                        })
                }
            }
        },
    }
</script>
<style scoped>
    .reg-back-btn {
        color: #f65923;
        font-size: 12px;
        font-weight: bold;
    }

    .reg .field {
        display: flex;
        flex-direction: column;
        padding: 10px 0px 10px 0px;
    }

    .reg .reg-err-msg {
        color: red;
        font-size: 12px;
        margin-top: 25px;
    }

    .reg-checkbox {
        font-size: 14px;
        line-height: 25px;
    }

    .reg .reg-btns {
        display: flex;
        flex-direction: column;
    }

    span.reg-chk-label {
        /*padding-left: 4px;*/
        color: rgb(82, 82, 82);
        font-weight: 400;
        font-size: 14px;
        font-family: var(--font-family);
        vertical-align: middle;
    }
        span.reg-chk-label a.pq4-link {
            color: rgb(82, 82, 82);
            font-weight: 400;
        }
        .reg .reg-btns {
            text-align: center;
        }

    .reg .dx-pass-value, .reg .dx-email-value {
    }


    .reg-loadpanel .dx-loadpanel-indicator.dx-loadindicator.dx-widget {
        margin: auto;
        display: block;
    }

    .login_aspx #pq4Logo {
        display: none;
    }

    .reg div#summary {
        margin-bottom: 10px;
    }

    .reg-welcome {
        font-size: 17px;
        text-align: center;
        margin: 10px 0px;
        font-weight: 700;
        color: #e97035;
    }

    .reg-welcome-text {
        font-size: 15px;
        text-align: center;
        margin-bottom: 5px;
    }

    .reg-footer {
        display: flex;
        justify-content: center;
    }

    .reg-footer-text {
        font-size: 12px;
    }

    .reg .reg-sign-btn {
        color: #f65923;
        font-size: 12px;
        font-weight: bold;
    }
</style>